export const numberRegex = (str) => {
  const outputString = `${str}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  return outputString;
};
